export const DeviceStatusColors = {
  on: 'green',
  off: 'red',
  disabled: 'grey'
};